import React, { useEffect, useState } from "react";
import { Button, Modal, Typography } from "antd";
import { DownloadOutlined, AppleOutlined } from "@ant-design/icons";

const { Paragraph, Title } = Typography;

let deferredPrompt: any = null;
const iOSShareButton = <svg style={{ verticalAlign: 'middle' }} xmlns="http://www.w3.org/2000/svg" fill="#000000" width="30px" height="30px" viewBox="0 0 50 50"><path d="M30.3 13.7L25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z"/><path d="M24 7h2v21h-2z"/><path d="M35 40H15c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3z"/></svg>


const isIOS = () =>
  /iphone|ipad|ipod/i.test(window.navigator.userAgent);

const isStandalone = () =>
  window.matchMedia("(display-mode: fullscreen)").matches ||
  (window.navigator as any).standalone === true;

const InstallButton: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [showIOSModal, setShowIOSModal] = useState(false);

  useEffect(() => {
    window.addEventListener("appinstalled", () => {
      setVisible(false);
    });

    const handler = (e: any) => {
      e.preventDefault();
      deferredPrompt = e;
      setVisible(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    if (isIOS() && !isStandalone()) {
      setVisible(true);
    }

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const handleInstall = async () => {
    if (isIOS()) {
      setShowIOSModal(true);
      return;
    }

    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;

      if (outcome === "accepted") {
        setVisible(false);
      }

      deferredPrompt = null;
    }
  };

  if (!visible) return null;

  return (
    <>
      <Button
        type="primary"
        icon={isIOS() ? <AppleOutlined /> : <DownloadOutlined />}
        onClick={handleInstall}
      >
        {isIOS() ? "Добавить на экран Домой" : "Скачать приложение"}
      </Button>

      <Modal
        open={showIOSModal}
        footer={null}
        onCancel={() => setShowIOSModal(false)}
      >
        <Title level={4}>Установка на iPhone</Title>

        <Paragraph>
          1️⃣ Нажмите кнопку <b>«Поделиться»</b> ({iOSShareButton}) внизу Safari
        </Paragraph>

        <Paragraph>
          2️⃣ Выберите <b>«На экран Домой»</b>
        </Paragraph>

        <Paragraph>
          3️⃣ Нажмите <b>«Добавить»</b>
        </Paragraph>
      </Modal>
    </>
  );
};

export default InstallButton;
